import type { AppProps, AppContext } from "next/app";
import "@meitu/x-design-roboneo-web-fork/lib/style.css";
import "@meitu/x-design-roboneo/dist/style.css";
import "@/styles/globals.css";
import { StoreProvider } from "easy-peasy";
import store from "@/store";
import AppLogic from "./appLogic";
import dynamic from "next/dynamic";
import { statTrack } from "@/utils/mtstat";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { pushSessionRecentPage } from "@meitu/xdesign-widgets/dist/utils/sessionRecentPages";
import { initViewportWidthBands } from "@/utils/viewportWidthBands";

initViewportWidthBands();

// @ts-ignore
const WpsPayModal = dynamic(
  () =>
    import("@meitu/xdesign-widgets/dist/wps").then((mod) => mod.WpsPayModal),
  {
    ssr: false,
  },
);

import("@meitu/xdesign-widgets/dist/teamExports").then(
  ({ initResignedListener }) => {
    initResignedListener();
  },
);

const MyApp = ({
  Component,
  pageProps,
}: AppProps & { isPersonal: boolean }) => {
  const router = useRouter();

  useEffect(() => {
    pushSessionRecentPage();
  }, [router.pathname]);

  return (
    <StoreProvider store={store}>
      <AppLogic />
      <WpsPayModal onStatTrack={statTrack} />
      <Component {...pageProps} />
    </StoreProvider>
  );
};

export default MyApp;
